// @flow
import type {Action} from '../../../state/types'

export type SetApiIndexPayload = {
  apiIndex: ApiIndex<MapApi>,
}

const id = 'map/SET_API_INDEX'

export const setApiIndex = (apiIndex: ApiIndex<MapApi>): Action<SetApiIndexPayload> => ({
  type: id,
  payload: {
    apiIndex,
  }
})

setApiIndex.id = id
